import { CartSummaryMethodsResults, getCartSummaryMethods } from "@NA/Services/ADICartSummaryService";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import { CartModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = CustomApiHandler<{
    cart?: CartModel,
} & HasOnSuccess<CartSummaryMethodsResults>, CartSummaryMethodsResults>;

//type HandlerType = CustomApiHandler& HasOnSuccess<UpdateCartApiParameter, <CartSummaryMethodsResults>;

export const DispatchvisualFilters: HandlerType = (props: any) => {
    props.dispatch({
        type: "Custom/loadCartSummary",
        result: props.parameter,
    });
};

export const LoadCartSummary: HandlerType = async (props: any) => {
    props.apiResult = await getCartSummaryMethods(props.parameter);
};

export const DispatchCompleteloadCartSummaryMethods: HandlerType = props => {
    props.dispatch({
        type: "Custom/DispatchCompleteGetCartSummary",
        cartSummaryMethod: props.apiResult,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [DispatchvisualFilters, LoadCartSummary, DispatchCompleteloadCartSummaryMethods, ExecuteOnSuccessCallback];

const loadCartSummary = createHandlerChainRunner(
    chain,
    "loadCartSummary",
);
export default loadCartSummary;